<template>
    <component
        :is="componentType"
        :to="to"
        :disabled="isDisabled"
        :class="buttonClasses"
        @click="handleClick"
    >
        <span
            v-if="loading"
            class="mr-2 inline-block h-4 w-4 animate-spin rounded-full border-2 border-current border-t-transparent"
        ></span>
        <slot />
    </component>
</template>

<script>
export default {
    name: 'ActionButton',
    props: {
        to: {
            type: [String, Object],
            default: null,
        },
        size: {
            type: String,
            default: 'default',
            validator: (value) => ['small', 'default', 'large'].includes(value),
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        muted: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        fullWidth: {
            type: Boolean,
            default: true,
        },
    },
    emits: ['click'],
    computed: {
        componentType() {
            return this.to ? 'RouterLink' : 'button'
        },
        isDisabled() {
            return this.disabled || this.loading
        },
        sizeClasses() {
            const sizes = {
                small: 'px-1 py-3 text-sm',
                default: 'p-4',
                large: 'px-6 py-5 text-lg',
            }
            return sizes[this.size]
        },
        buttonClasses() {
            return [
                'font-semibold transition-colors text-center inline-flex items-center justify-center',
                this.fullWidth ? 'block w-full' : 'inline-block',
                this.sizeClasses,
                this.muted
                    ? this.isDisabled
                        ? 'bg-gray-300 text-titles cursor-not-allowed'
                        : 'bg-card-2 text-white hover:bg-card'
                    : this.isDisabled
                      ? 'bg-gray-300 text-titles cursor-not-allowed'
                      : 'bg-red-600 text-white hover:bg-red-700',
            ]
        },
    },
    methods: {
        handleClick(event) {
            if (!this.isDisabled) {
                this.$emit('click', event)
            }
        },
    },
}
</script>
